import { render, staticRenderFns } from "./PainelComiteGestaoPessoas.vue?vue&type=template&id=88751d2c"
import script from "./PainelComiteGestaoPessoas.vue?vue&type=script&lang=js"
export * from "./PainelComiteGestaoPessoas.vue?vue&type=script&lang=js"
import style0 from "./PainelComiteGestaoPessoas.vue?vue&type=style&index=0&id=88751d2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports